/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDeepCompareMemo } from "hooks/use-deep-compare-memo";
import { quillToTipTapJson } from "./rich-text-utils";
import { isRichTextQuill } from "./use-rich-text-to-html";

export function useEnsureTipTapContent (richtext) {
    return useDeepCompareMemo(
        () => {
            const isQuill = isRichTextQuill(richtext);
            const tiptapContent = isQuill ? quillToTipTapJson(richtext) : richtext;

            return {
                isQuill,
                tiptapContent
            };
        },
        [richtext]
    );
}
